 <template>
  <div class="container">
    <div class="header">
      <div
        class="diningRoom-class"
        style="font-size: 16px; font-weight: 700"
        @click="showDiningRoomList"
      >
        {{ diningRoomInfo.name }}
      </div>

      <div class="input-class-wrapper" style="align-items: center">
        <img
          :src="require('@/assets/order/1@2x(4).png')"
          style="width: 14px; height: 14px; margin-left: 10px"
        />
        <input
          class="input-class"
          v-model="searchInputVaule"
          placeholder="请输入商品名称进行查询"
          @input="searchInput"
        />
      </div>

      <img
        v-if="deskCode || keyCode"
        :src="require('@/assets/order/1@2x(1).png')"
        class="header-right-img"
        @click="recordsConsumption"
      />
    </div>
    <!-- 主体内容 -->
    <div class="main-content">
      <div class="content">
        <!-- 左侧分类导航 -->
        <div class="category-nav" style="font-size: 14px; color: #737a84">
          <div
            v-for="(item, index) in catalogList"
            :key="index"
            @click="choosecategory(item)"
          >
            <div v-if="item.id === catalogId" class="category-item active">
              <p style="text-align: center; flex: 1; position: relative">
                {{ item.name }}
              </p>
              <p
                v-if="item.num > 0"
                class="red-good-num"
                style="position: absolute; margin-top: -35px; margin-left: 4rem"
              >
                {{ item.num }}
              </p>
            </div>
            <div v-else class="category-item">
              <p style="text-align: center; flex: 1; position: relative">
                {{ item.name }}
              </p>
              <p
                v-if="item.num > 0"
                class="red-good-num"
                style="position: absolute; margin-top: -35px; margin-left: 4rem"
              >
                {{ item.num }}
              </p>
            </div>
          </div>
        </div>

        <!-- 右侧菜品列表 -->
        <div class="menu-list" ref="menuList">
          <div
            v-for="(item, index) in goodsList"
            :key="index"
            :ref="`catalog-${item.GoodsCatalogId}`"
          >
            <div class="menu-item" :key="item.GoodsCatalogId">
              <div class="image-container">
                <img
                  v-if="item.PicUrl && item.PicUrl.length > 0"
                  :src="item.PicUrl"
                  class="goods-PicUrl"
                />

                <img
                  v-else
                  :src="require('@/assets/order/1@2x(20).png')"
                  style="
                    height: 142px;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                  "
                />
                <p class="recommend-tag" v-if="item.IsRecommend == 1">推荐菜</p>

                <img
                  class="sell-out"
                  v-if="
                    item.IsSellOut &&
                    item.IsSellOut === '是' &&
                    item.SellOutNumber &&
                    item.SellOutNumber === 0
                  "
                  :src="require('@/assets/order/1@2x(15).png')"
                />
              </div>
              <div
                class="goodsname-item"
                style="font-size: 14px; font-weight: 700;margin-top: 12px;"
              >
                {{ item.GoodsName }}
              </div>
              <p
                v-if="item.Description && item.Description.length > 0"
                style="color: #97a0a9"
              >
                {{ item.Description }}
              </p>
              <div class="goodsname-item" style="display: flex; height: 40px">
                <div style="width: auto; font-size: 16px; font-weight: 700">
                  {{ item.Price }}
                </div>
                <div class="goods-Unit" style="font-size: 12px">
                  元 / {{ item.Unit ? item.Unit : "份" }}
                </div>
                <div style="flex: 1"></div>
                <div
                  v-if="
                    (item.TasteArray && item.TasteArray.length > 0) ||
                    (item.MethodArray && item.MethodArray.length > 0)
                  "
                  @click="showSpecificPop(item)"
                  class="goods-Specific-btn"
                >
                  选规格
                </div>
                <div v-else style="display: flex;">
                  <img
                    v-if="item.num > 0"
                    :src="require('@/assets/order/1@2x(8).png')"
                    class="img-add"
                    @click="updateNumberLess(item, index)"
                  />
                  <div
                    v-if="item.num > 0"
                    style="font-size: 16px; font-weight: 700"
                    class="goods-num"
                  >
                    {{ item.num }}
                  </div>
                  <img
                    :src="require('@/assets/order/1@2x(9).png')"
                    class="img-add-right"
                    @click="updateNumberAdd(item, index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部订单栏 -->
    <div class="order-bar">
      <img
        :src="require('@/assets/order/1@2x(5).png')"
        style="width: 28px; height: 28px"
        @click="showGoodsCardPop"
      />
      <div
        class="category-item"
        style="
          color: #737a84;
          font-size: 16px;
          width: auto;
          margin-left: 10px;
          font-weight: 700;
        "
      >
        {{ allCount }}
      </div>
      <div style="flex: 1;height: 100%;display: flex;align-items: center;">
        <div style="flex: 1;"/>
         <div style="width: 1px;height: 100%;background-color: rgba(151,160,169,0.4);"></div>
          <div style="flex: 1;"/>
      </div>

      <div
        class="category-item"
        style="color: #737a84; width: auto; font-size: 18px; font-weight: 700"
      >
        {{ allMoney.toFixed(2) }}
      </div>
      <div
        style="
          color: #737a84;
          width: auto;
          font-size: 14px;
          margin-left: 5px;
          font-weight: 600;
        "
      >
        元
      </div>
      <div style="flex: 1" />
      <div
        class="confirm-btn"
        style="
          font-size: 16px;
          height: 50px;
          line-height: 50px;
          font-weight: 700;
        "
        @click="handleToOrderPage"
      >
        确认
      </div>
    </div>

    <!-- 这是购物车 -->
    <van-popup
      class="shop_cart_con"
      round
      v-model="maskType"
      position="bottom"
      :overlay-style="{
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }"
    >
      <div class="cartTitle">
        <span> 已选餐品 </span>
        <div class="clear" @click="clearShoppingCar">
          <van-icon name="delete-o" size="17" />
          <span>清空购物车</span>
        </div>
      </div>
      <div class="cart_goods_con">
        <div style="display: flex; flex-direction: column">
          <div
            v-for="(group, index) in allCarGoodsArr"
            :key="index"
            style="margin-left: 20px; margin-right: 20px"
          >
            <p style="color: #737a84">{{ group.GoodsCatalogName }}</p>
            <div
              v-for="(item, j) in group.children"
              :key="j"
              style="margin-top: 5px; height: 80px"
            >
              <div style="display: flex">
                <img
                  v-if="item.PicUrl && item.PicUrl.length > 0"
                  :src="item.PicUrl"
                  style="width: 110px; height: 70px; border-radius: 10px"
                />
                <img
                  v-else
                  :src="require('@/assets/order/1@2x(20).png')"
                  style="width: 110px; height: 70px; border-radius: 4px"
                />
                <div style="flex: 1">
                  <div
                    class="goodsname-item"
                    style="font-size: 14px; font-weight: 700"
                  >
                    {{ item.GoodsName }}
                  </div>
                  <div
                    class="goodsname-item"
                    style="display: flex; height: 40px"
                  >
                    <div style="width: auto; font-size: 14px; font-weight: 700">
                      {{ item.Price }}
                    </div>
                    <div
                      class="goods-Unit"
                      style="font-size: 12px; color: #737a84"
                    >
                      元 / {{ item.Unit ? item.Unit : "份" }}
                    </div>
                    <div style="flex: 1"></div>
                    <img
                      v-if="item.num > 0"
                      :src="require('@/assets/order/1@2x(8).png')"
                      class="img-add"
                      @click="updateNumberLess(item, index)"
                    />
                    <div
                      v-if="item.num > 0"
                      class="goods-num"
                      style="font-size: 16px; font-weight: 500"
                    >
                      {{ item.num }}
                    </div>
                    <img
                      :src="require('@/assets/order/1@2x(9).png')"
                      class="img-add-right"
                      @click="updateNumberAdd(item, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cart_footer">
       
       <div style="flex: 1; margin-left: 20px;">
        <div
          style="
            width: 100%;
            color: #737A84;
            font-size: 18px;
            display: flex;
            text-align: left;
            margin-top: 10px;
            height: 20px;
            font-weight: 700
          "
        >
          <p style="font-size: 14px; font-weight: normal;padding-right: 5px;">合计 :</p>
          {{ allMoney.toFixed(2) }}
          <p style="font-size: 14px; font-weight: normal; margin-left: 5px">
            元
          </p>
        </div>
        <p style="color: #B7BDC3; font-size: 12px">共计{{ allCount }}道菜</p>
      </div>

         <div style="flex: 1;display: flex;margin-left: 20px;">
         <div style="display: flex;flex-direction: column;align-items: center;"> 

          <img
          :src="require('@/assets/order/other@2x.png')"
          style="width: 28px; height: 28px;"
        />
         <p style="font-size: 12px;color: #97A0A9;">购物车
          <p style="width: 16px;height: 16px;line-height: 16px; border-radius: 16px;margin-top: -40px;background-color: #FF7D66;margin-left: 30px;font-size: 12px;color: white;text-align: center;">{{allCount}}</p>
         </p>
         </div>
       
        <div
          class="confirm-btn"
          style="
          flex: 1;
            margin-right: 0px;
            font-size: 16px;
            height: 40px;
            margin-left: 30px;
            line-height: 40px;
            margin-right: 16px;
            font-weight: 700;
          "
          @click="handleToOrderPage"
        >
          立即下单
        </div>
         </div>

       
        
      </div>
    </van-popup>

    <!-- 这是购物车删除按钮 -->
    <van-overlay
      :show="showBuyCardDeletedModal"
      z-index="20000"
      :style="{
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }"
    >
      <div class="overlay_con" style="margin-left: 10px; margin-right: 10px">
        <div class="overlay_con_content">
          <p style="text-align: center; height: 30px"></p>
          <p class="overlay_con_p" style="font-size: 16px">
            挑了好久呢，全部都不要了吗？～
          </p>

          <div
            style="
              margin-left: 40px;
              margin-right: 40px;
              margin-top: 30px;
              display: flex;
              font-size: 16px;
            "
          >
            <van-button
              color="#E1EDDE"
              block
              round
              class="cancel-custom-button"
              @click="deleteAllGoodsForSeleted"
              >狠心删除</van-button
            >
            <div style="width: 40px" />
            <van-button
              color="#E1EDDE"
              block
              round
              class="custom-button"
              @click="showBuyCardDeletedModal = false"
              >继续保留</van-button
            >
          </div>

          <div style="height: 30px" />
        </div>
      </div>
    </van-overlay>

    <!-- 这是餐厅切换弹窗-->
    <van-overlay
      :show="showDiningModal"
      z-index="20000"
      :style="{
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }"
    >
      <div class="overlay_con" style="margin-left: 10px; margin-right: 10px">
        <div class="overlay_con_content">
          <p class="dining-modal-title">餐厅切换</p>
          <div style="display: flex; flex-direction: column; margin-top: 20px">
            <div v-for="(item, index) in diningRoomList" :key="index">
              <div class="dining-item" @click="choosediningRoom(item)">
                <img class="dining-roomImg" :src="item.roomImg" />
                <p style="flex: 1">{{ item.Name }}</p>
                <img
                  class="dining-choose"
                  v-if="item.Id === preDiningRoomId"
                  :src="require('@/assets/images/wl_right.png')"
                />
                <img v-else />
              </div>
            </div>
          </div>
          <div
            style="
              margin-left: 40px;
              margin-right: 40px;
              margin-top: 30px;
              display: flex;
            "
          >
            <van-button
              color="#E1EDDE"
              block
              round
              class="cancel-custom-button"
              @click="cancelSwitchDining"
              >取消</van-button
            >
            <div style="width: 40px" />
            <van-button
              color="#E1EDDE"
              block
              round
              class="custom-button"
              @click="sureSwitchDining"
              >确认</van-button
            >
          </div>

          <div style="height: 30px" />
        </div>
      </div>
    </van-overlay>

    <!-- 备注 -->
    <van-popup
      class="multiSpecific_cart_con"
      round
      v-model="multiSpecific"
      position="bottom"
      :overlay-style="{
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }"
    >
      <div class="multiSpecific-goods-message">
        <img
          :src=" mGoodItem.PicUrl ? mGoodItem.PicUrl : require('@/assets/order/1@2x(20).png')"
          class="multiSpecific-goods-image"/>

        <div class="multiSpecific-goods-name">
          <div class="goodsname-item" style="font-size: 14px; font-weight: 700;">
            {{ mGoodItem.GoodsName }}
          </div>
          <div style="display: flex; margin-left: 20px">
            <div style="width: auto; font-size: 16px; font-weight: 700">
              {{ mGoodItem.Price }}
            </div>
            <div class="goods-Unit" style="font-size: 16px">
              元 / {{ mGoodItem.Unit ? mGoodItem.Unit : "份" }}
            </div>
          </div>
        </div>

      </div>
       <div  class="multiSpecific-content">
          <div style="height: auto;width: 100%;margin-top: 30px;">
             <p class="goodsname-item" style="font-size: 14px; font-weight: 700">菜品备注</p>
             <div class="grid-container">
              <div :class="mGoodItem.SeletedGoodsRemarkArray.includes(item)?'grid-item-activity':'grid-item'"  v-for="(item, index) in mGoodItem.GoodsRemarkArray" :key="index"
               @click="chooseRemark(item)">
                 <p v-if="mGoodItem.SeletedGoodsRemarkArray.includes(item)" class="grid-text-activity" style="font-size: 14px;">{{ item }}</p>
                <p v-else class="grid-text" style="font-size: 14px;">{{ item }}</p>
             </div>
             </div>
            <input class="multiSpecific-input"/>

      <div class="cart_footer">
       
       <div style="flex: 1; margin-left: 20px;">
        <div
          style="
            width: 100%;
            color: #737A84;
            font-size: 18px;
            display: flex;
            text-align: left;
            margin-top: 10px;
            height: 20px;
            font-weight: 700
          "
        >
          <p style="font-size: 14px; font-weight: normal;padding-right: 5px;">合计 :</p>
          {{ allMoney.toFixed(2) }}
          <p style="font-size: 14px; font-weight: normal; margin-left: 5px">
            元
          </p>
        </div>
        <p style="color: #B7BDC3; font-size: 12px">共计{{ allCount }}道菜</p>
      </div>

         <div style="flex: 1;display: flex;margin-left: 20px;">
         <div style="display: flex;flex-direction: column;align-items: center;"> 
          <img
          :src="require('@/assets/order/other@2x.png')"
          style="width: 28px; height: 28px;"
        />
         <p style="font-size: 12px;color: #97A0A9;">购物车
          <p style="width: 16px;height: 16px;line-height: 16px; border-radius: 16px;margin-top: -40px;background-color: #FF7D66;margin-left: 30px;font-size: 12px;color: white;text-align: center;">{{allCount}}</p>
         </p>
         </div>
       
        <div
          class="confirm-btn"
          style="
          flex: 1;
            margin-right: 0px;
            font-size: 16px;
            height: 40px;
            margin-left: 30px;
            line-height: 40px;
            margin-right: 16px;
            font-weight: 700;"
          @click="handleToOrderPage"
        >
          立即下单
        </div>
         </div> 
      </div>
          </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { Search, Badge, Popup, Dialog, Toast } from "vant";
import { handleSessionStorage } from "@/utils";
import { getDiningRoomList, getFoodList } from "@/api/foodOrder";
export default {
  name: "NewMicropoint",
  data() {
    return {
      maskType: false,
      multiSpecific: false,
      showBuyCardDeletedModal: false,
      showDiningModal: false,
      searchInputVaule: "",
      deskCode: "",
      keyCode: "",
      teamId: "",
      diningRoomId: "",
      saasCode: "",
      isSureVpn: false,
      allMoney: 0.0,
      allCount: 0,
      preVpnInfo: {},
      preDiningRoomId: "",
      diningRoomInfo: {},
      diningRoomList: [],
      allCarGoodsArr: [],
      catalogList: [],
      catalogId: "",
      goodsListOrigin: [],
      goodsList: [],
      catalogRefs: {},
      seletedGoodMap: {},
      EnableTeamOrder: false,
      mGoodItem: {},
    };
  },
  created() {
    this.EnableTeamOrder = handleSessionStorage.get("EnableTeamOrder");
    const deskCode = handleSessionStorage.get("deskCode");
    this.deskCode = deskCode && deskCode.code;
    this.keyCode = deskCode && deskCode.cardCode;
    this.teamId = handleSessionStorage.get("teamId");
    this.saasCode = this.$route.query.saasCode;
    this.diningRoomId = this.$route.query.diningRoomId;
    this.isSureVpn = handleSessionStorage.get("isSureVpn"); //此时确认唯一门店,true时不可切换门店
    // 用于判断是否选择过门店
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.preVpnInfo = vpnStorage;
    this.diningRoomId = handleSessionStorage.get("diningRoomId");
    this.preDiningRoomId = this.diningRoomId;
    this.seletedGoodMap = handleSessionStorage.get("NewGoods");
    if (this.seletedGoodMap == null || this.seletedGoodMap == undefined) {
      this.seletedGoodMap = {};
    }
    // 加载商品列表
    this.handleGetVpnList();
  },
  methods: {
    chooseRemark(item) {
      this.$nextTick(() => {
        const have = this.mGoodItem.SeletedGoodsRemarkArray.find((mode) => mode === item);
        if (have != undefined) {
          this.mGoodItem.SeletedGoodsRemarkArray =
            this.mGoodItem.SeletedGoodsRemarkArray.filter(
              (mode) => mode != item
            );
        } else {
          this.mGoodItem.SeletedGoodsRemarkArray.push(item);
        }
      });
    },
    showSpecificPop(item) {
      this.mGoodItem = item;
      this.multiSpecific = true;
    },
    cancelSwitchDining() {
      this.showDiningModal = false;
      this.preDiningRoomId = this.diningRoomInfo.id;
    },
    choosediningRoom(dining) {
      this.preDiningRoomId = dining.Id;
    },
    /*切换餐厅*/
    sureSwitchDining() {
      this.showDiningModal = false;
      const item = this.diningRoomList.find(
        (mode) => mode.Id == this.preDiningRoomId
      );
      if (item != undefined) {
        const deskObj = handleSessionStorage.get("deskCode");
        handleSessionStorage.set("deskCode", {
          ...deskObj,
          ...item,
        });
        this.handleSelectDiningRoom(item);
      }
    },
    //显示切换餐厅弹窗
    showDiningRoomList() {
      if (this.vpnInfo.EnableSwitchDiningRoom == true) {
        this.preDiningRoomId = this.diningRoomInfo.id;
        this.showDiningModal = true;
      }
    },
    //历史消费
    recordsConsumption() {
      this.$router.push({
        name: "MicropointHistoryConsume",
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    handleToOrderPage() {
      this.$router.push({
        name: "MicropointCurrentConsume",
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    clearShoppingCar() {
      this.showBuyCardDeletedModal = true;
    },
    showGoodsCardPop() {
      this.maskType = true;
      this.showGoodsCard();
    },
    showGoodsCard() {
      this.allCarGoodsArr = [];
      const list = Object.values(this.seletedGoodMap);
      const typeArray = [];
      list.forEach((mode) => {
        if (!typeArray.includes(mode.GoodsCatalog)) {
          typeArray.push(mode.GoodsCatalog);
        }
      });
      typeArray.forEach((GoodsCatalog) => {
        const children = list.filter(
          (mode) => GoodsCatalog == mode.GoodsCatalog
        );
        this.allCarGoodsArr.push({
          GoodsCatalogName: GoodsCatalog,
          children: children,
        });
      });
      if (this.allCarGoodsArr.length == 0) {
        this.maskType = false;
      }
    },
    /**删除所有已选商品*/
    deleteAllGoodsForSeleted() {
      this.showBuyCardDeletedModal = false;
      this.maskType = false;
      this.seletedGoodMap = {};
      this.updateCatalogCount();
      this.goodsList.forEach((mode, index) => {
        mode.num = 0;
        this.goodsList[index] = mode;
      });
      this.showGoodsCard();
    },
    updateCatalogCount() {
      this.allMoney = 0.0;
      this.allCount = 0;
      const list = Object.values(this.seletedGoodMap);
      // this.$toast(JSON.stringify(list));
      if (list) {
        this.catalogList.forEach((mode, index) => {
          mode.num = 0;
          const child = list.filter((item) => item.GoodsCatalogId == mode.id);
          child.forEach((item) => {
            mode.num = mode.num + item.num;
            this.allMoney = this.allMoney + item.num * item.Price;
            this.allCount = this.allCount + item.num;
          });
          this.catalogList[index] = mode;
        });
      }
      handleSessionStorage.set("NewGoods", this.seletedGoodMap);
    },
    searchInput(event) {
      this.goodsList = [];
      const name = event.target.value;
      this.goodsListOrigin.forEach((mode, index) => {
        if (name == "" || name.length == 0) {
          this.goodsList.push(mode);
        } else {
          if ((mode.GoodsName + "").includes(name)) {
            this.goodsList.push(mode);
          }
        }
      });
    },
    updateNumberAdd(item, index) {
      const SellOutNumber = item.SellOutNumber && item.SellOutNumber === 0;
      const IsSellOut = item.IsSellOut && item.IsSellOut === "是";
      if (IsSellOut && SellOutNumber) {
        this.$toast(item.GoodsName + "已售罄");
        return;
      }
      item.num = item.num + (item.MinBuyCount ? item.MinBuyCount : 1);
      const isFirst = item.num === (item.MinBuyCount ? item.MinBuyCount : 1);
      const TasteArray = item.TasteArray ? item.TasteArray : [];
      const MethodArray = item.TasteArray ? item.MethodArray : [];
      const GoodsRemarkArray = item.GoodsRemarkArray? item.GoodsRemarkArray: [];
      if (
        (isFirst && TasteArray.length > 0) ||
        MethodArray.length > 0 ||
        GoodsRemarkArray.length > 0
      ) {
        item.SeletedGoodsRemarkArray = [];
        this.mGoodItem = item;
        this.multiSpecific = true;
        return;
      }

      const mIndex = this.goodsList.findIndex(
        (mode) => mode.GoodsCode === item.GoodsCode
      );
      if (mIndex != -1) {
        this.goodsList[mIndex] = item;
      }
      this.$set(this.seletedGoodMap, item.GoodsCode, item);
      this.updateCatalogCount();
    },
    /**点击商品减号*/
    updateNumberLess(item, index) {
      if (item.num > 1) {
        item.num = item.num - (item.MinBuyCount ? item.MinBuyCount : 1);
        this.$set(this.seletedGoodMap, item.GoodsCode, item);
      } else {
        item.num = 0;
        this.$delete(this.seletedGoodMap, item.GoodsCode);
      }
      const mIndex = this.goodsList.findIndex(
        (mode) => mode.GoodsCode === item.GoodsCode
      );
      if (mIndex != -1) {
        this.goodsList[mIndex] = item;
      }
      this.showGoodsCard();
      this.updateCatalogCount();
    },
    /***点击左侧类别*/
    choosecategory(item) {
      this.catalogId = item.id;
      this.$nextTick(() => {
        const refName = `catalog-${item.id}`;
        const elements = this.$refs[refName];
        if (elements && elements.length > 0) {
          const element = elements[0];
          const container = this.$refs.menuList;
          // 计算滚动位置
          const scrollTop = element.offsetTop - container.offsetTop - 20; // 20px偏移量
          // 平滑滚动
          container.scrollTo({
            top: scrollTop,
            behavior: "smooth",
          });
        }
      });
    },

    handleGetVpnList() {
      $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
        this.vpnList = res.Items;
        if (this.saasCode) {
          const vpnItem = this.vpnList.find(
            (item) => item.SaaSCode == this.saasCode
          );
          if (vpnItem) {
            this.handleSubmitSelectVpn(vpnItem);
          } else {
            this.handleSubmitSelectVpn(this.vpnList[0]);
          }
        } else if (this.preVpnInfo) {
          const vpnItem = this.vpnList.find(
            (item) => item.SaaSCode == this.preVpnInfo.code
          );
          if (vpnItem) {
            this.handleSubmitSelectVpn(vpnItem);
          } else {
            this.handleSubmitSelectVpn(this.vpnList[0]);
          }
        }
      });
    },

    handleSubmitSelectVpn(item, flag) {
      this.vpnInfo = {
        name: item.Name,
        code: item.SaaSCode,
        id: item.Id,
        ...item.SaasVpnSetting,
      };
      handleSessionStorage.set("vpnInfo", this.vpnInfo);
      this.showSelectVpnModal = false;
      this.handleGetDiningRoomList();
    },

    handleSubmitSelectDiningRoom(item, flag) {
      this.diningRoomInfo = {
        name: item.Name,
        id: item.Id,
      };
      this.swipeList = item.banners;
      this.mealTipImg = item.tipBanners.length > 0 ? item.tipBanners[0] : "";
      this.showMealTipModal = !!this.mealTipImg;
      handleSessionStorage.set("diningRoomId", item.Id);
      handleSessionStorage.set("diningRoomInfo", item);
      this.showSelectDiningRoomModal = false;
      if (this.EnableTeamOrder && this.isSureVpn) {
        this.handleInitConnet();
      } else {
        // 加载商品列表
        this.getGoodsList(flag);
      }
    },

    handleInitConnet() {
      // 建立连接
      initConnect();
      if (this.$store.state.pointConnet) {
        handleSendMessage("SendGoodsList", {
          TeamId: this.teamId,
          duration: this.vpnInfo.OrderTeamDuration,
        });
      }
      EventBus.$on("getMessage", (data) => {
        // 接收服务端发送来的消息
        console.log("点单页成功收到了-------------", data);
        if (data.Quantity > 0) {
          //   //某商品增加了
          this.handlePlusNum(data, data.Quantity, "isOtherPoint");
        } else {
          this.handleMinusNum(data, -data.Quantity, "isOtherPoint");
        }
      });
      EventBus.$on("getGroupGoodsList", (data, isClear) => {
        // 接收服务端发送来的消息
        console.log("点单页初始列表收到了-------------", data);

        // this.carGoodsList = goodsArr;
        // 初始化购物车商品
        this.$store.commit("shopCart/initCardList", data);
        if (isClear) {
          this.deleteAllGoodsForSeleted();
        } else {
          // 加载商品列表
          this.getGoodsList();
        }
      });
      // this.getGoodsList();
    },

    handleGetDiningRoomList() {
      getDiningRoomList({ vpnId: this.vpnInfo.id }).then((res) => {
        if (!res || res.length == 0) {
          Toast("未获取到餐厅信息，请检查后台餐厅设置");
          return;
        }
        res.forEach((item) => {
          if (!item.ImageUrl || item.ImageUrl.length == 0) {
            item.roomImg = this.$root.defaultImg;
            item.banners = [];
          } else {
            const imgArr = item.ImageUrl.split(",");
            item.roomImg = item.CdnUrl + "/" + imgArr[0];
            item.banners = imgArr.map((iItem) => item.CdnUrl + "/" + iItem);
          }
          if (!item.TipImageUrl || item.TipImageUrl.length == 0) {
            item.tipBanners = [];
          } else {
            const imgArr = item.TipImageUrl.split(",");
            item.tipBanners = imgArr.map((iItem) => item.CdnUrl + "/" + iItem);
          }
        });
        this.diningRoomList = res;
        if (this.diningRoomId) {
          const vpnItem = this.diningRoomList.find(
            (item) => item.Id == this.diningRoomId
          );
          if (vpnItem) {
            this.handleSelectDiningRoom(vpnItem);
          }
        } else if (this.preDiningRoomId) {
          const vpnItem = this.diningRoomList.find(
            (item) => item.Id == this.preDiningRoomId
          );
          if (vpnItem) {
            this.handleSelectDiningRoom(vpnItem);
          }
        } else {
          this.handleSelectDiningRoom(this.diningRoomList[0]);
        }
      });
    },

    handleSelectDiningRoom(item) {
      if (this.diningRoomInfo.id) {
        Dialog.confirm({
          message: "切换餐厅将清除已点购物车餐品，确认切换吗？",
        }).then(() => {
          // on confirm
          this.searchKey = "";
          // 清空购物车
          this.deleteAllGoodsForSeleted();
          // if (this.isSureVpn && this.isSureVpn) {
          //  this.handleSendMessage("SendGoodsClear", {
          //     TeamId: this.teamId,
          //     duration: this.vpnInfo.OrderTeamDuration,
          //   });
          // }
          this.handleSubmitSelectDiningRoom(item, "second");
        });
      } else {
        this.handleSubmitSelectDiningRoom(item);
      }
    },

    getGoodsList(flag) {
      this.catalogList = [];
      this.goodsList = [];
      if (this.seletedGoodMap == null || this.seletedGoodMap == undefined) {
        this.seletedGoodMap = {};
      }

      getFoodList({
        code: this.vpnInfo.code,
        diningRoomId: this.diningRoomInfo.id,
        vpnId: this.vpnInfo.id,
      }).then((res) => {
        res.forEach((item, index) => {
          item.Goods.forEach((mode, index) => {
            // if (index % 2 === 0) {
            //   mode.TasteArray = ["麻辣", "清淡", "重盐"];
            //   mode.MethodArray = ["煎炸", "清蒸", "爆炒"];
            // }
            item.Goods[index] = mode;
          });
          const itemGoodsList = item.Goods;
          const catalog = {
            id: item.GoodsCatalogId,
            name: item.GoodsCatalogName,
            num: 0,
          };
          if (index == 0) {
            this.catalogId = item.GoodsCatalogId;
          }
          if (itemGoodsList && itemGoodsList.length > 0) {
            itemGoodsList.forEach((mode, j) => {
              const temp =
                this.seletedGoodMap != null
                  ? this.seletedGoodMap[mode.GoodsCode]
                  : {};
              mode.num = temp != null ? temp.num : 0;
              itemGoodsList[j];
            });
            this.catalogList.push(catalog);
            this.goodsList.push(...itemGoodsList);
          }
        });
        this.catalogListOrigin = this.catalogList;
        this.goodsListOrigin = this.goodsList;
        this.updateCatalogCount();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  width: 100%;
  height: 100px;
  align-items: center;
  background-color: #f6faf5;
}
.diningRoom-class {
  color: #303541;
  font-size: 30px;
  text-align: center;
  width: 23%;
}
.input-class-wrapper {
  display: flex;
  background-color: white;
  border-radius: 70px;
  height: 70px;
  flex: 1;
  font-size: 28px;
  text-align: center;
  border: 1px solid white;
}
.input-class {
  height: 70px;
  flex: 1;
  margin-right: 50px;
  border: 1px solid white;
}
.header-right-img {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  margin-right: 20px;
}
.main-content {
  width: 100%;
  flex: 1;
}
.content {
  display: flex;
  width: 100%;
  height: 100%;
}
.category-nav {
  width: 30%;
  align-items: center;
  height: 100%;
  background-color: #fcfcfc;
}
.category-item {
  height: 80px;
  width: 100%;
  text-align: center;
  color: #737a84;
  line-height: 80px;
}
.category-item.active {
  height: 80px;
  width: 100%;
  text-align: center;
  color: #849d80;
  font-weight: 600;
  line-height: 80px;
  background-color: #d7e8d3;
  border-bottom-left-radius: 60px;
  border-top-left-radius: 60px;
}
.menu-list {
  width: 100%;
  padding: 15px;
  overflow-y: auto;
  height: calc(100vh - 0px);
  padding-bottom: 250px;
}
.menu-item {
  display: flex;
  flex-direction: column;
  height: auto;
  border: 1px solid #eeeded;
  border-radius: 4px;
  margin-bottom: 20px;
}
.image-container {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
}
.goodsname-item {
  text-align: left;
  color: #555c67;
  font-size: 16px;
  height: 60px;
  margin-left: 20px;
  margin-right: 20px;
  width: 100%;
  font-weight: 700;
  text-align: left;
  line-height: 60px;
}
.goods-PicUrl {
  height: 284rpx;
  width: 100%;
  object-fit: cover;
  transition: transform 0.3s;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.recommend-tag {
  position: absolute;
  top: 0px;
  right: -1px;
  background: #bedf88; /* 红色背景 */
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 24px;
  font-weight: bold;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.2); */
  border-top-right-radius: 10px;
  border-bottom-left-radius: 20px;
}
.sell-out {
  position: absolute;
  top: 58px;
  left: 6.3rem;
  width: 164px;
  height: 164px;
}

.goods-Unit {
  width: auto;
  color: #737a84;
  margin-left: 6px;
  font-size: 12px;
}
.goods-num {
  min-width: 50px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #97a0a9;
  font-size: 16px;
}
.img-add {
  width: 40px;
  height: 40px;
}
.img-add-right {
  width: 40px;
  height: 40px;
  margin-right: 26px;
}
.order-bar {
  @include fixed-bottom-box-con;
  height: 50px;
  align-items: center;
  margin-left: 30px;
  margin-right: 30px;
  border: 1px solid lightgray;
  display: flex;
  border-radius: 60px;
  margin-bottom: 50px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0px 2px 6px 0px rgba(164, 193, 158, 0.4);
  backdrop-filter: blur(2px);
}

.confirm-btn {
  margin-right: -31px;
  height: 50px;
  line-height: 50px;
  background-color: RGBA(234, 242, 232, 1);
  color: #849d80;
  height: 100%;
  border-radius: 60px;
  width: 240px;
  text-align: center;
}

.red-good-num {
  width: auto;
  padding-left: 8px;
  padding-right: 8px;
  height: 30px;
  line-height: 30px;
  background-color: red;
  border-radius: 40px;
  color: white;
  text-align: center;
  font-size: 25px;
}

.overlay_con_content {
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  background-color: white;
  border-radius: 10px;
  align-items: center;
  color: #737a84;
  font-size: 37px;
}
.overlay_con_p {
  text-align: center;
  margin-top: 40px;
  height: 48px;
  line-height: 48px;
  color: #737a84;
  font-size: 16px;
}
.custom-button {
  color: #849d80 !important;
  font-weight: bold;
  font-size: 16px;
}
.cancel-custom-button {
  color: #97a0a9 !important;
  font-weight: bold;
  font-size: 16px;
  background: white !important;
  border: 1px solid #eaeaea;
}

.shop_cart_con {
  .cartTitle {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    background: #f5f5f5;
    height: 90px;
    font-size: 28px;
    color: #333;
    font-weight: bold;

    .clear {
      height: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      color: #999;
      font-size: 24px;
      font-weight: normal;

      .van-icon {
        margin-right: 5px;
      }
    }
  }

  .cart_goods_con {
    width: 100%;
    max-height: 50vh;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 14px 0px;
  }
  .cart_footer {
    height: 200px;
    display: flex;
    flex-direction: column;
    border-top: 1px solid rgba(151, 160, 169, 0.3);
    margin-bottom: 50px;
    background: white;
  }
}
.historyOrderCon {
  position: fixed;
  right: 16px;
  bottom: 250px;
  z-index: 3;
  width: 106px;
  height: 106px;
  text-align: center;
  border-radius: 50%;
  padding-top: 28px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: -2px 0px 13px 0px #849d80;
  font-size: 24px;
}
.dining-modal-title {
  color: #303541;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 40px;
  border-bottom: 1px solid #eeeded;
  padding-bottom: 20px;
}
.dining-item {
  display: flex;
  height: 5rem;
  align-items: center;
  color: #303541;
  font-size: 1.2rem;
}
.dining-roomImg {
  height: 4rem;
  width: 4rem;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 4rem;
}
.dining-choose {
  width: 40px;
  height: 40px;
  margin-right: 20px;
}

.goods-Specific-btn {
  width: 100px;
  height: 35px;
  line-height: 35px;
  background: #e1edde;
  font-weight: 700;
  margin-right: 30px;
  border-radius: 20px;
  font-size: 16px;
  color: #849d80;
  text-align: center;
}
.multiSpecific_cart_con {
  background: transparent;
  width: 100%;
}

.multiSpecific-goods-message {
  width: 80%;
  margin-left: 10%;
  height: 200px;
  display: flex;
  z-index: 9999999;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(191, 206, 188, 0.4);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.multiSpecific-goods-image {
  width: 30%;
  margin-left: 2%;
  margin-top: 5%;
  height: 60%;
  border-radius: 16px;
  object-fit: cover;
}

.multiSpecific-goods-name {
  flex: 1;
  margin-left: 10px;
  margin-top: 5%;
  font-weight: 700;
  font-size: 16px;
  height: auto;
}
.multiSpecific-content {
  height: auto;
  width: 100%;
  z-index: 0;
  margin-top: -30px;
  min-height: 300px;
  background: white;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 60px;
  border-top-right-radius: 60px;
}
.multiSpecific-input {
  height: 80px;
  width: 90%;
  padding-left: 10px;
  margin-left: 5%;
  background: white;
  border-radius: 20px;
  border: 1px solid #eaeaea;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
  padding: 15px;
  max-height: 500px;
  background: white;
  border-radius: 16rpx;
}

.grid-item {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}

.grid-item-activity {
  background:#E1EDDE;
  border: 1px solid rgba(132, 157, 128, 0.4);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}

.grid-text {
  color: #97a0a9;
  font-size: 28rpx;
  font-weight: bold;
}

.grid-text-activity {
  background:white;
  color: #737a84;
  font-size: 28rpx;
  font-weight: bold;
}
.multiSpecific-footer{


}
</style>